import React, {useCallback, useEffect, useRef, useState} from 'react';
import HeaderPage from '../../../../palette/HeaderPage';
import {FormContainer, Layout, LayoutChild} from '../../../../palette/Palette';
import {inject, observer} from 'mobx-react';
import RadioGroup from 'devextreme-react/radio-group';
import {db} from "../../../../firebase/Firebase";
import format from "date-fns/format";
import {es} from "date-fns/locale";
import {Button} from "devextreme-react/button";
import SelectBox from 'devextreme-react/select-box';
import {Popup} from "devextreme-react/popup";
import {FilterDelete, Filters} from "../../../../utils/HelpFunctions";
import axios from "axios";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";

const priorities = ['Conductores', 'Pasajeros', 'Todos'];

const actualDataYear = format(new Date(), 'yyyy')
const now = new Date()

const buttonOptions = {
    text: 'Enviar',
    type: 'success',
    useSubmitBehavior: true,
    id: 'add-button-routes',
    icon: 'far fa-check-circle'
};

const dataPromotions = {
    title: '',
    body: '',
}

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

//const url = 'http://localhost:8080/send-notification';
const url = 'https://send-notification-easi4xatjq-uc.a.run.app/send-notification';

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function Notifications(props) {
    const {DataStore} = props;

    const {companyName, idCompany, userName, userMail} = DataStore

    const [submitButton] = useState(buttonOptions)
    const [dataSource, setDataSource] = useState(dataPromotions)
    const [radioValues, setRadioValues] = useState(priorities[0])
    const [promotions, setPromotions] = useState([])
    const [trigger, setTrigger] = useState(false);
    const [textButton, setTextButton] = useState('Enviar notificación')
    const [popupVisible, setPopupVisible] = React.useState(false);
    const [load, setLoad] = useState(false)
    const [disabledSelected, setDisabledSelected] = useState(true)
    const [titlePromotion, setTitlePromotion] = useState('')
    const [data, setData] = useState(null)
    const [passengers, setPassengers] = useState(null)
    const [drivers, setDrivers] = useState(null)
    const [to, setTo] = useState('Drivers')
    const [success, setSuccess] = useState(false)

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()
    const dxForm = useRef(null);

    const mainPath = db.collection(companyName).doc(idCompany).collection('Promotions')
    const mainDb = db.collection(companyName).doc(idCompany)

    useEffect(() => {
        let mounted = true;

        const GetDataDrivers = async () => {
            await mainDb.collection('DriverManagement')
                .where("state", "==", 'Activo')
                .get()
                .then((querySnapshot) => {
                    const array = []
                    querySnapshot.forEach((doc) => {
                        const newObject = {tokenPush: doc.data().tokenPush}
                        array.push(newObject)
                    });
                    const filterTokens = FilterDelete(array, 'tokenPush', '');
                    setDrivers(filterTokens)
                })
        }

        GetDataDrivers().catch(() => {
            //console.log("Error getting documents: ", error);
        });

        return () => {
            mounted = false
        }

    }, [])

    useEffect(() => {
        let mounted = true;

        const GetDataPassengers = async () => {
            await mainDb.collection('PassengersManagement').where("state", "==", 'Activo')
                .get()
                .then((querySnapshot) => {
                    const array = []
                    querySnapshot.forEach((doc) => {
                        const newObject = {tokenPush: doc.data().tokenPush}
                        array.push(newObject)
                    });
                    const filterNull = FilterDelete(array, 'tokenPush', null);
                    setPassengers(filterNull)
                })
        }

        GetDataPassengers().catch(() => {
            //console.log("Error getting documents: ", error);
        });

        return () => {
            mounted = false
        }

    }, [])

    useEffect(() => {

        const GetPromotions = async () => {
            let ID = 0
            await mainPath.where('year', '==', actualDataYear).onSnapshot((querySnapshot) => {
                const newArray = [];
                querySnapshot.forEach(doc => {
                    if (doc.exists) {
                        ID = ID + 1
                        let value;
                        if (doc.data().value) {
                            value = doc.data().value
                        } else {
                            value = 0
                        }
                        const start = new Date(doc.data().start.seconds * 1000)
                        const end = new Date(doc.data().end.seconds * 1000)
                        const obj = {...doc.data(), docId: doc.id, ID: ID, start: start, end: end, value: value};
                        newArray.push(obj);
                    } else {
                        setPromotions([]);
                    }
                })

                const filterDates = newArray.filter(items => format(items.start, 'yyyy-MM-dd') >= format(new Date(), 'yyyy-MM-dd'))

                const filterState = Filters(filterDates, 'state', 'Aprobada')
                setPromotions(filterState);
            })
        }

        if (isMounted()) {
            GetPromotions().catch(() => setTrigger(!trigger));
        }
    }, [trigger, isMounted])

    const onValueSelectChanged = (e) => {
        if (e.value !== '') {
            const filterPromotions = Filters(promotions, 'tittle', e.value)

            const parseStart = new Date(Date.parse(filterPromotions[0].start));
            const parseEnd = new Date(Date.parse(filterPromotions[0].end));
            const startStr = format(parseStart, "dd 'de' MMMM 'del' yyyy", {locale: es})
            const endStr = format(parseEnd, "dd 'de' MMMM 'del' yyyy", {locale: es})

            const body = `Valido desde el ${startStr} hasta el ${endStr}.
                  \nPuede ser usado en ${filterPromotions[0].numClients} reservas
                  \n!Aplica en la sección de promociones !`

            let title;

            if (filterPromotions[0].percentage > 0) {
                const percentage = filterPromotions[0].percentage * 100
                title = `${filterPromotions[0].tittle}: ${percentage}% de descuento`
            } else {
                title = `${filterPromotions[0].tittle}: $${filterPromotions[0].value} de descuento`
            }

            setDataSource({...dataSource, title: title, body: body})

            setTitlePromotion(e.value)
        }
    }

    const onValueRadioChanged = (e) => {

        setRadioValues(e.value)
        const {instance} = dxForm.current
        instance.resetValues()
        if (e.value === 'Pasajeros') {
            setTo('Passengers')
            setDisabledSelected(false)
        } else {
            setDisabledSelected(true)
        }

        if (e.value === 'Conductores') {
            setTo('Drivers')
        }

        if (e.value === 'Todos') {
            setTo('All')
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const date = format(now, 'yyyy-MM-dd')
        const month = format(now, 'MMMM', {locale: es})
        const year = format(now, 'yyyy')

        const dateArray = date.split('-');
        const num = Math.floor(Math.random() * 100) + 1;
        const cod = `${dateArray[1]}${dateArray[dateArray.length - 1]}${num.toString()}`;

        setData({
            ...dataSource, companyName, idCompany, radioValues, date, year, month, userName, userMail,
            cod, passengers, drivers, to
        })

        setPopupVisible(true)
    }

    const sendNotification = async () => {

        setTextButton('Enviando...')
        setLoad(true)

        const {instance} = dxForm.current

        await axios.post(url, data, {headers: headers})
            .then(res => {
                if (res.data === 'OK') {
                    setSuccess(true)
                    setTimeout(() => {
                        instance.resetValues()
                        setSuccess(false)
                        setPopupVisible(false)
                        setLoad(false)
                        setTitlePromotion('Conductores')
                        setTextButton('Enviar promoción')
                    }, 1500)
                } else {
                    setSuccess(false)
                    setTextButton('Enviar notificacion')
                    setPopupVisible(false)
                    setLoad(false)
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                }
            }).catch((e) => {
                console.log(e)
                setSuccess(false)
                setTextButton('Enviar notificación')
                setPopupVisible(false)
                setLoad(false)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="cancellations-container">
                <HeaderPage icon={'far fa-paper-plane'} text={'Notificaciones'} load={true}
                            textLoad={'Guardando....'}/>

                <Popup
                    visible={popupVisible}
                    onHiding={() => setPopupVisible(false)}
                    dragEnabled={false}
                    closeOnOutsideClick={false}
                    showCloseButton={false}
                    showTitle={true}
                    title={`Enviar Notificacion`}
                    width={320}
                    height={'auto'}>
                    <span style={{fontSize: 12,}}>Esta seguro que desea enviar la notificacion. ?</span>
                    <div style={{marginTop: 5}}/>
                    <Layout>
                        {success && <Alerts severity={'success'} body={'Notificación enviada exitosamente'}/>}
                    </Layout>
                    <div style={{marginTop: 5}}/>
                    <Layout color="transparent" row center space>
                        <Button
                            width={100}
                            height={30}
                            type="normal"
                            stylingMode="outlined"
                            disabled={load}
                            onClick={() => {
                                const {instance} = dxForm.current
                                instance.resetValues()
                                setLoad(false)
                                setPopupVisible(false)
                            }}
                        >
                            <i className="far fa-arrow-alt-circle-left" style={{fontSize: '10px'}}/>
                            <span style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 5}}>Salir</span>
                        </Button>

                        <Button
                            width={150}
                            height={30}
                            type="success"
                            disabled={load}
                            stylingMode="contained"
                            onClick={sendNotification}
                        >
                            <i className="far fa-check-circle" style={{fontSize: '10px'}}/>
                            <span style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 5}}>{textButton}</span>
                        </Button>
                    </Layout>

                </Popup>
                <div style={{height: 30}}/>
                <LayoutChild color='transparent' width='95%' margin='auto'>
                    <Layout color='transparent' row center space>
                        <div className="dx-field-value">
                            <RadioGroup items={priorities} value={radioValues} layout={'horizontal'}
                                        itemRender={renderCustomItem} onValueChanged={onValueRadioChanged}/>
                        </div>
                        <div className="dx-field-value">
                            <SelectBox id="custom-templates"
                                       dataSource={promotions}
                                       displayExpr="tittle"
                                       valueExpr="tittle"
                                       disabled={disabledSelected}
                                       value={titlePromotion}
                                       onValueChanged={onValueSelectChanged}
                            />
                        </div>
                    </Layout>
                    <FormContainer>

                        <form action="" onSubmit={handleSubmit}>
                            <Form
                                ref={dxForm}
                                formData={dataSource}
                                readOnly={false}
                                showColonAfterLabel={true}
                                validationGroup="create-promotions"
                            >
                                <GroupItem caption="Datos" colCount={1}>
                                    <SimpleItem dataField="title" label={{text: 'Asunto'}}>
                                        <RequiredRule message="Ingrese el asunto"/>
                                    </SimpleItem>

                                    <SimpleItem dataField="body" label={{text: 'Descripcion'}} editorType={'dxTextArea'}
                                                editorOptions={{height: 120,}}>
                                        <RequiredRule message="Ingrese una Descripcion"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem colCount={1}>
                                    <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                                </GroupItem>
                            </Form>
                        </form>
                    </FormContainer>
                </LayoutChild>
            </div>
        </>
    )

}

export default inject('DataStore', 'ControlStore')(observer(Notifications));

function renderCustomItem(data) {
    return <div>{data}</div>;
}
